module.exports = __webpack_public_path__ + "static/media/request-feature.12e82ae5.svg";